"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appendOnlyAtom = appendOnlyAtom;
exports.atom = atom;
exports.reset = reset;
exports.swap = swap;
exports.deref = deref;
exports.addWatch = addWatch;
exports.removeWatch = removeWatch;

var _mori = require("mori");

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var INVALID_ATOM_KEY_ERROR_MSG = "An atom's watch key should be a string.";
var ATOM_SWAP_ARG_NOT_A_FN_MSG = "The fn provided to swap should be a function.";

var Atom = function () {
  function Atom(initialValue, validatorFn) {
    _classCallCheck(this, Atom);

    this.state = initialValue;
    this.validatorFn = validatorFn || (0, _mori.constantly)(true);
    this.watches = (0, _mori.hashMap)();
  }

  /* Replaces the current state of the atom with the result of
   * applying the provided function to it.
   *
   * @param fn Function that provides the new value, given the current state it's argument.
   */

  _createClass(Atom, [{
    key: "swap",
    value: function swap(fn) {
      if (fn instanceof Function) {
        return this.reset(fn.apply(this, [this.deref()].concat([].slice.call(arguments, 1))));
      } else {
        console.log(ATOM_SWAP_ARG_NOT_A_FN_MSG);
        throw new Error(ATOM_SWAP_ARG_NOT_A_FN_MSG);
      }
    }

    /* Adds a watch using the given key that triggers the provided
     * callback function if the value of the atom changes.
      * @param key A string that describes the watch being added.
     * @param fn The callback function to call when the value of the atom changes.
     */

  }, {
    key: "addWatch",
    value: function addWatch(key, fn) {
      if (fn instanceof Function) {
        if (typeof key === "string") {
          this.watches = (0, _mori.assoc)(this.watches, key, fn);
        } else {
          console.log("The provided key should be a string");
          throw new Error(INVALID_ATOM_KEY_ERROR_MSG);
        }
      } else {
        throw new Error("The provided fn should really be a function.");
      }
    }

    /* Removes the watch function with the given key.
     *
     * @param key The key of the callback function to remove from the Atom.
     */

  }, {
    key: "removeWatch",
    value: function removeWatch(key) {
      this.watches = (0, _mori.dissoc)(this.watches, key);
    }
  }, {
    key: "notify",
    value: function notify(currentState, newState, kv) {
      // console.log("Notifying: ", first(kv));
      var watchKey = (0, _mori.first)(kv);
      var watchFn = (0, _mori.second)(kv);

      if (typeof watchKey === "string") {
        watchFn(currentState, newState);
      } else if ((0, _mori.isMap)(currentState) && (0, _mori.isMap)(newState)) {
        console.log("The provided key should be a string");
        throw new Error(INVALID_ATOM_KEY_ERROR_MSG);
      }
    }
  }, {
    key: "notifyAll",
    value: function notifyAll(currentState, newState) {
      if (!(0, _mori.isEmpty)(this.watches)) {
        (0, _mori.each)(this.watches, (0, _mori.partial)(this.notify, currentState, newState));
      }
    }
  }]);

  return Atom;
}();

var AppendOnlyAtom = function (_Atom) {
  _inherits(AppendOnlyAtom, _Atom);

  function AppendOnlyAtom(initialValue, validatorFn) {
    _classCallCheck(this, AppendOnlyAtom);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(AppendOnlyAtom).call(this, (0, _mori.list)(initialValue), validatorFn));
  }

  /* Resets the value of the atom to the value of the provided
   * newState argument and calls any watch functions if applicable.
   *
   * @param newState The new value of the atom.
   */

  _createClass(AppendOnlyAtom, [{
    key: "reset",
    value: function reset(newState) {
      var currentState = this.deref();

      if (this.validatorFn(newState)) {
        // append the new state to the internal state sequence
        this.state = (0, _mori.conj)(this.state, newState);

        // notify all watches
        this.notifyAll(currentState, newState);

        return newState;
      } else {
        return false;
      }
    }

    /* Dereferences the atom, i.e. returns it's most recent state. */

  }, {
    key: "deref",
    value: function deref() {
      return (0, _mori.first)(this.state);
    }
  }]);

  return AppendOnlyAtom;
}(Atom);

// TODO: I don't think I like calling this a mutable atom
// it sends the wrong message

var MutableAtom = function (_Atom2) {
  _inherits(MutableAtom, _Atom2);

  function MutableAtom(initialValue, validatorFn) {
    _classCallCheck(this, MutableAtom);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(MutableAtom).call(this, initialValue, validatorFn));
  }

  /* Resets the value of the atom to the value of the provided
   * newState argument and calls any watch functions if applicable.
   *
   * @param newState The new value of the atom.
   */

  _createClass(MutableAtom, [{
    key: "reset",
    value: function reset(newState) {
      var currentState = this.deref();

      if (this.validatorFn(newState)) {
        // overwrite the existing state
        this.state = newState;
        // notify all watches
        this.notifyAll(currentState, newState);

        return newState;
      } else {
        return false;
      }
    }

    /* Dereferences the atom, i.e. returns it's most recent state. */

  }, {
    key: "deref",
    value: function deref() {
      return this.state;
    }
  }]);

  return MutableAtom;
}(Atom);

function appendOnlyAtom(initialValue, validatorFn) {
  return new AppendOnlyAtom(initialValue, validatorFn);
}

function atom(initialValue, validatorFn) {
  return new MutableAtom(initialValue, validatorFn);
}

function reset(a, newState) {
  return a.reset(newState);
}

function swap(a, fn) {
  return a.swap(fn);
}

function deref(a) {
  return a.deref();
}

function addWatch(a, key, fn) {
  return a.addWatch(key, fn);
}

function removeWatch(a, key) {
  return a.removeWatch(key);
}